import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
export const SkillSortList = (data, params) => {
  return apiBaseUrl.post('talent/client/skills/list', data, { params: params });
};

export const spSkillSortList = (data, params) => {
  return apiBaseUrl.post('sptalentsd/client/skills/list', data, { params: params });
};
